/**
 * Isolate a fragment so it cannot reorder the sentence around it.
 *
 * The panel is Persian-first, so most rendered text is RTL. Latin codes (`SUMMER25`),
 * numerals, `%` and the minus sign are all bidi-NEUTRAL or weak: the Unicode bidi algorithm
 * resolves them against the surrounding paragraph, which in RTL puts them where a reader of
 * English would not expect. Concretely, a leading `−` before a figure can render to the
 * right of it — reading as a trailing mark — and a code embedded in a Persian sentence can
 * swap ends with the words beside it.
 *
 * FSI…PDI (U+2066 / U+2069) is the "first strong isolate" pair: the fragment gets its own
 * direction from its own first strong character, and neither influences nor is influenced by
 * the text around it. Preferred over LRM/RLM marks, which push direction rather than
 * isolating, and over `<bdi>` where the value is going into a string rather than JSX.
 *
 * Use for: promotion codes, currency figures, percentages, IDs — anything Latin or numeric
 * that appears inside translated prose. Not needed for a whole line that is only a figure,
 * though it is harmless there.
 */
const FSI = '⁦'
const PDI = '⁩'

export const isolate = (value: string | number): string =>
  `${FSI}${value}${PDI}`
